export const AP_REQUEST_SAMPLE_LOADER = {
  desktop: `
<div class="cui">
  <div style="padding: 18px 0; box-shadow: 0 -1px 0 0 #e8e8e8 inset">
    <div class="cui-grid cui-container">
      <div class="cui-skeleton-rectangle -is--block" style="width: 126px">
        <div class="cui-skeleton__item" style="width: 100%; height: 36px"></div>
      </div>
    </div>
  </div>
  <div class="cui-grid cui-container -spacing--top-32 -spacing--bottom-120">
    <div class="cui-row">
      <div class="cui-col-lg-7 cui-col-md-8">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 28px"></div>
        </div>
        <div class="cui-skeleton-heading -size--large -resolution--desktop -spacing--top-64">
          <div class="cui-skeleton-heading__content" style="width: 100%">
            <div class="cui-skeleton__item cui-skeleton-heading__title" style=""></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="height: 72px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="height: 72px"></div>
        </div>
        <div class="cui-skeleton-button -size--large -spacing--top-64" style="display: flex; justify-content: flex-end">
          <div class="cui-skeleton-button__content" style="width: 227px">
            <div class="cui-skeleton__item cui-skeleton-button__button"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  `,
  mobile: `
  <div class="cui">
  <div style="padding: 14px 0; box-shadow: 0 -1px 0 0 #e8e8e8 inset">
    <div class="cui-grid cui-container">
      <div class="cui-skeleton-rectangle -is--block" style="width: 126px">
        <div class="cui-skeleton__item" style="width: 100%; height: 36px"></div>
      </div>
    </div>
  </div>
  <div class="cui-grid cui-container -spacing--top-24 -spacing--bottom-64">
    <div class="cui-row">
      <div class="cui-col-12">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 28px"></div>
        </div>
        <div class="cui-skeleton-heading -size--medium -resolution--desktop -spacing--top-16">
          <div class="cui-skeleton-heading__content" style="width: 100%">
            <div class="cui-skeleton__item cui-skeleton-heading__title" style=""></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="height: 72px"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-16">
          <div class="cui-skeleton__item" style="height: 72px"></div>
        </div>
        <div class="cui-skeleton-button -size--large -spacing--top-40" style="display: flex; justify-content: flex-end">
          <div class="cui-skeleton-button__content" style="width: 100%">
            <div class="cui-skeleton__item cui-skeleton-button__button"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  `
};
